import { useUser } from 'contexts/UserContext'
import { useEffect } from 'react'

export default function Logout() {
  // Hook para gestionar el usuario actual
  const { setUser } = useUser()

  useEffect(() => {
    setUser({})

    if (document.body.classList.contains('dark')) {
      document.body.classList.remove('dark')
    }
  }, [])

  return <></>
}
